/**
 * Global Draft Guard Middleware
 *
 * DISABLED: This middleware is not in use.
 * Navigation guards are now handled at the page level using onBeforeRouteLeave
 * and the useDraftNavigationGuard composable for a consistent modal experience.
 *
 * See: app/composables/useDraftNavigationGuard.ts
 */

export default defineNuxtRouteMiddleware((to, from) => {
  // Middleware disabled - navigation guards handled at page level
  return
})
